// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__23Yjj","additionalInfo":"AgreementModal_additionalInfo__84HEG"};